import "vue";
import "./WIconStd/index.js";
import "./WIconExt/index.js";
function iconToProp(prop) {
  if (typeof prop === "string") {
    return { name: prop };
  }
  return prop;
}
export {
  iconToProp
};
